import Vue from "vue";

export default function guest({ store })
{
    // only following condition means actually authenticated
    if (store.getters["auth/authenticated"] && ! Vue.prototype.$cache.get('redirect-to-password-reset'))
    {
        return 'onboarding';
    }

    return false;
}
